import { api } from "services/axios/api";
import { getErrorsByApi } from "shared/helpers/getErrorsByApi";
import { ICadastrosN2, ISalvarCadastrosN2 } from "shared/interfaces/cadastrosN2";

interface IApiResponse {
  id?: number;
  empresaId: number;
  acessoCadastroTipologiasLiberadas: boolean;
  acessoSolicitacoesTipologias: boolean;
  modoUtilizacao?: number; // Legado
  modoEnvio?: boolean;
  modoValidacao?: boolean;
  modoHomologacao?: boolean;
  projetistasCadastroTipologias: number[];
  projetistasSolicitacoes: number[];
  seriais: Array<{
    id?: number;
    serial: string;
    projetistasIds: number[];
  }>;
  emails: Array<{
    id?: number;
    nomeDestinatario: string;
    email: string;
  }>;
}

/**
 * Cadastros N2 da PRÓPRIA empresa do usuário logado (id vem do token). Plano de 07/09/2026,
 * Frente 1 — mesma razão de getMinhaEmpresa: o endpoint por id exige a tela Configuracao.
 *
 * `propagarErro` (plano de 22/09/2026, Frente 3): as telas de N2 precisam distinguir "não consegui
 * ler a configuração" de "a empresa não configurou projetista nenhum" — as duas terminavam na mesma
 * mensagem de "nenhum registro encontrado". O menu segue no comportamento tolerante (sem o
 * parâmetro), porque uma falha aqui não pode impedir o resto da montagem dele.
 * 404 continua sendo ausência de configuração nos dois modos, não erro.
 */
export const getMeusCadastrosN2 = async (
  opcoes?: { propagarErro?: boolean }
): Promise<ICadastrosN2 | null> => {
  try {
    const { data } = await api.get<IApiResponse>(`/MinhaEmpresa/ObterMeusCadastrosN2`);
    if (!data) {
      return null;
    }
    return data as ICadastrosN2;
  } catch (error: any) {
    if (error.response?.status === 404) {
      return null;
    }
    if (opcoes?.propagarErro) {
      throw error;
    }
    getErrorsByApi(error, "Erro ao buscar configurações de Cadastros N2");
    return null;
  }
};

export const getCadastrosN2PorEmpresaId = async (empresaId: number): Promise<ICadastrosN2 | null> => {
  try {
    const { data } = await api.get<IApiResponse>(`/Empresa/ObterCadastrosN2PorIdEmpresa?empresaId=${empresaId}`);
    if (!data) {
      return null;
    }
    return data as ICadastrosN2;
  } catch (error: any) {
    if (error.response?.status === 404) {
      return null;
    }
    getErrorsByApi(error, "Erro ao buscar configurações de Cadastros N2");
    return null;
  }
};

export const postSalvarCadastrosN2 = async (dados: ISalvarCadastrosN2): Promise<number> => {
  try {
    const { data } = await api.post<number>("/Empresa/SalvarCadastrosN2", dados);
    return data;
  } catch (error: any) {
    getErrorsByApi(error, "Erro ao salvar Cadastros N2");
    throw error;
  }
};

